import React, { FC, FormEvent, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HolidaysFilterData } from "../../../shared/models/employee.model";
import useSpinnerLoader from "../../../shared/components/spinner-loader";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import YearInput from "../../../shared/components/atoms/year-input";

interface FilterFormProps {
  onFilter: (data: any) => void;
}

const HolidaysFilterForm: FC<FilterFormProps> = ({ onFilter }) => {
  const [filterData, setFilterData] = useState<any>({
    year: new Date(), 
  });
  const { loaderComponent } = useSpinnerLoader();

  return (
    <>
      {loaderComponent}
      <div className="row row-gap-3">
        <div className="col-sm-12 col-md-3">
          <label className="form-label">เลือกปี</label>
          <YearInput date={filterData.year} onChange={(e:any) => {
            setFilterData({
              ...filterData,
              year: e,
            });
            onFilter({
              ...filterData,
              year: e,
            });
          }} required={true} />
        </div>
          
      </div>
    </>
  );
};

export default HolidaysFilterForm;
